import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useSearch } from "../../../hooks/seach/useSearch";
import { styles } from "./styles";

export default function Forwarded() {
    const {
        estadoOcorrencia, setEstadoOcorrencia
    } = useSearch();

    return (
        <>
            <Typography style={styles.labelInput}>
                Status das Ocorrências: *
            </Typography>
            <FormControl variant="outlined" style={styles.formControl}>
                <Select
                    onChange={e => setEstadoOcorrencia(e.target.value)}
                    value={estadoOcorrencia}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    <MenuItem value="true">Encaminhadas</MenuItem>
                    <MenuItem value="false">Não Encaminhadas</MenuItem>
                </Select>
            </FormControl>
        </>
    );
}